export const typeItems = [
    { key: 'labour', label: 'Labour' },
    { key: 'material_with_po', label: 'Material With PO' },
    { key: 'material_without_po', label: 'Material Without PO' },
    { key: 'consumables_with_po', label: 'Consumables With PO' },
    { key: 'consumables_without_po', label: 'Consumables Without PO' },
    { key: 'other', label: 'Other' },
]

export const statusItems = [
    { key: 'draft', label: 'Draft' },
    { key: 'expended', label: 'Expended' },
]